export default() => {

  // loading element
  const divEl = document.createElement('div');
  divEl.id ='loading';
  const imgEl = document.createElement('img');
  imgEl.setAttribute('src', 'img/common/loading.svg');
  imgEl.setAttribute('alt', 'Now Loading...');
  divEl.appendChild(imgEl);

  const bodyEl = document.getElementsByTagName('body')[0];
  bodyEl.appendChild(divEl);

  // prevent scroll
  bodyEl.style.position = 'fixed';

  // after loading
  window.addEventListener('load', () => {
    const loadingEl = document.getElementById('loading');

    setTimeout(() => {
      loadingEl.style.opacity = 0;

      setTimeout(() => {
        // allow scroll
        bodyEl.style.position = 'relative';
        loadingEl.style.display = 'none';
      }, 1000);
    }, 1000);
  });
}